import classnames from 'classnames/bind';
import { FC, ReactNode } from 'react';
import styles from './PayeeInfo.module.scss';

const cx = classnames.bind(styles);

type Props = {
  label: string;
  value: ReactNode;
  valueClassName?: string;
  rowClassName?: string;
};

export const PayeeInfoRow: FC<Props> = ({
  label,
  value,
  valueClassName,
  rowClassName,
}) => {
  return (
    <div className={cx(styles['payee-info-row'], rowClassName)}>
      <span className={cx(styles['payee-info-label'])}>{label}</span>
      <span className={cx(styles['payee-info-value'], valueClassName)}>
        {value}
      </span>
    </div>
  );
};

PayeeInfoRow.displayName = 'PayeeInfoRow';
